import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { SessionUser, Membership } from '../../types/domain';

export interface AuthState {
  user: SessionUser | null;
  memberships: Membership[];
  hydrated: boolean;
  loading: boolean;
}

const initialState: AuthState = {
  user: null,
  memberships: [],
  hydrated: false,
  loading: false,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setSession(state, action: PayloadAction<{ user: SessionUser; memberships: Membership[] }>) {
      state.user = action.payload.user;
      state.memberships = action.payload.memberships || [];
      state.hydrated = true;
    },
    setActiveTenant(state, action: PayloadAction<{ tenantId: number; tenantName: string | null; tenantCode: string | null; roleName: string | null }>) {
      if (state.user) {
        state.user = {
          ...state.user,
          tenantId: action.payload.tenantId,
          tenantName: action.payload.tenantName,
          tenantCode: action.payload.tenantCode,
          roleName: action.payload.roleName,
        };
      }
    },
    clearSession(state) {
      state.user = null;
      state.memberships = [];
      state.hydrated = true;
    },
    setHydrated(state, action: PayloadAction<boolean>) {
      state.hydrated = action.payload;
    },
  },
});

export const { setLoading, setSession, setActiveTenant, clearSession, setHydrated } = slice.actions;
export default slice.reducer;
